import { getCardStyles } from '@quno/onboarding/src/generator/configs/componentMapper';
import { defaultLocale } from '@quno/onboarding/src/constants/locales';
import { BeforeAfterPhotoCard } from '@quno/patient-journey/src/components/Card/Variants/BeforeAfterPhotoCard';
import { renderImage } from '@quno/patient-journey/src/contentful/patient-journey/renderImage';
import { CARD_IMAGE_MAX_WIDTH } from '@quno/patient-journey/src/constants/image';
import { Base } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Base';
import type { BeforeAfterContainer } from '@quno/onboarding/src/generator/types/Models';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';

type BeforeAndAfterProps = BeforeAfterContainer & {
  locale: FormLocales;
};

export const BeforeAndAfter = (props: BeforeAndAfterProps): JSX.Element => {
  const { attributes } = props ?? {};
  const cardStyles = getCardStyles(props);
  const beforeAndAfterCards = attributes?.beforeAfterCards?.[defaultLocale];

  return (
    <Base {...props}>
      <>
        {beforeAndAfterCards?.map((beforeAndAfterCard, index) => {
          const { attributes } = beforeAndAfterCard ?? {};
          const beforeImageAttr = attributes?.beforeImage?.[defaultLocale];
          const afterImageAttr = attributes?.afterImage?.[defaultLocale];
          const borderRadius = cardStyles?.card.borderRadius;

          const beforeImage = beforeImageAttr?.url
            ? renderImage(beforeImageAttr, {
                container: true,
                maxWidth: CARD_IMAGE_MAX_WIDTH,
              })
            : null;

          const afterImage = afterImageAttr?.url
            ? renderImage(afterImageAttr, {
                container: true,
                maxWidth: CARD_IMAGE_MAX_WIDTH,
              })
            : null;

          return (
            <BeforeAfterPhotoCard
              key={index}
              beforePhoto={beforeImage}
              afterPhoto={afterImage}
              cardBorderRadius={borderRadius}
            />
          );
        })}
      </>
    </Base>
  );
};
